<template>
  <v-combobox
    :key="selectCountKey"
    :value="value"
    :search-input="value"
    :items="addressItems"
    rounded
    filled
    v-bind="$attrs"
    @update:search-input="onUpdateSearchInput"
    @input="onUpdateInput">
  </v-combobox>
</template>

<script>
import {
  searchAddressByDistrict as searchAddressBySubdistrict,
  searchAddressByAmphoe as searchAddressByDistrict,
  searchAddressByProvince,
  searchAddressByZipcode
} from 'thai-address-database'

export default {
  name: 'BaseThaiAddressAutocomplete',
  props: {
    addressType: {
      type: String,
      default: '',
      validator: (val) => ['subdistrict', 'district', 'stateProvince', 'zipCode'].includes(val)
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectCountKey: 0
    }
  },
  computed: {
    mapAddressType () {
      const typeData = {
        subdistrict: 'district',
        district: 'amphoe',
        stateProvince: 'province',
        zipCode: 'zipcode'
      }

      return typeData[this.addressType]
    },
    addressItems () {
      let result = []
      if (!this.value) {
        return result
      }

      switch (this.addressType) {
        case 'district':
          result = searchAddressByDistrict(this.value)
          break
        case 'stateProvince':
          result = searchAddressByProvince(this.value)
          break
        case 'zipCode':
          result = searchAddressByZipcode(this.value)
          break
        default:
          result = searchAddressBySubdistrict(this.value)
          break
      }

      return result.map((item) => (
        { text: this.addressTextTemplate(item), value: JSON.stringify(item) }
      ))
    }
  },
  methods: {
    addressTextTemplate ({ district, amphoe, province, zipcode }) {
      return `${district} » ${amphoe} » ${province} » ${zipcode}`
    },
    onUpdateSearchInput (value) {
      if (value) {
        this.$emit('input', value)
      }
    },
    onUpdateInput ({ value }) {
      if (value) {
        const parseValue = JSON.parse(value)
        const { district, amphoe, province, zipcode } = parseValue
        this.$emit('select', { subdistrict: district, district: amphoe, stateProvince: province, zipCode: zipcode })
        this.selectCountKey += 1
      }
    }
  }
}
</script>
